import { render, staticRenderFns } from "./Article1.vue?vue&type=template&id=14cf2990&scoped=true&"
import script from "./Article1.vue?vue&type=script&lang=js&"
export * from "./Article1.vue?vue&type=script&lang=js&"
import style0 from "./Article1.vue?vue&type=style&index=0&id=14cf2990&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cf2990",
  null
  
)

export default component.exports